import { useState, useEffect } from 'react';
import '@/styles/layouts/AppLayout.scss';
import AppHeader from './AppHeader';
import AppSidebar from './AppSidebar';
import { Outlet, useLocation } from 'react-router-dom';
import localForage from 'localforage';

function AppLayout() {
    const [isToggled, setIsToggled] = useState(false);
    const [isCorporationSelected, setIsCorporationSelected] = useState(false);
    const location = useLocation();

    // Check for corporate_token on component mount and path change
    useEffect(() => {
        const checkCorporateToken = async () => {
            const token = await localForage.getItem('corporate_token');
            setIsCorporationSelected(!!token); // Enable sidebar only if corporate_token exists
        };

        checkCorporateToken();
    }, [location]);

    return (
        <>
            <section className="app-layout">
                <AppSidebar
                    isToggled={isToggled}
                    setIsToggled={setIsToggled}
                    disabled={!isCorporationSelected} // Disable sidebar if no corporation selected
                />
                <section>
                    <AppHeader toggleSidebar={() => setIsToggled(!isToggled)} />
                    <main>
                        <Outlet />
                    </main>
                </section>
            </section>
        </>
    );
}

export default AppLayout;
